import takeAll from "./takeAll.js";
import flatL from "../Lazy/flatL.js";
export default function flat(iter) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return takeAll(flatL(iter, depth));
}